/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ReturnSalesOrderDto = {
  /**
   * Reason for return
   */
  returnReason: ReturnSalesOrderDto.returnReason;
  /**
   * Additional notes about the return
   */
  returnNotes?: string;
  /**
   * Condition of all items being returned
   */
  itemCondition: ReturnSalesOrderDto.itemCondition;
  /**
   * Restocking fee percentage (0-100)
   */
  restockingFeePercentage?: number;
  /**
   * Whether to apply restocking fee
   */
  applyRestockingFee?: boolean;
  /**
   * Bank reference or transaction ID for refund
   */
  refundReference?: string;
  /**
   * Additional refund notes
   */
  refundNotes?: string;
  /**
   * Custom refund amount (overrides automatic calculation). Must not exceed refundable amount.
   */
  customRefundAmount?: number;
};
export namespace ReturnSalesOrderDto {
  /**
   * Reason for return
   */
  export enum returnReason {
    DEFECTIVE = 'DEFECTIVE',
    WRONG_ITEM = 'WRONG_ITEM',
    NOT_AS_DESCRIBED = 'NOT_AS_DESCRIBED',
    CUSTOMER_CHANGED_MIND = 'CUSTOMER_CHANGED_MIND',
    SIZE_ISSUE = 'SIZE_ISSUE',
    QUALITY_ISSUE = 'QUALITY_ISSUE',
    OTHER = 'OTHER',
  }
  /**
   * Condition of all items being returned
   */
  export enum itemCondition {
    NEW = 'NEW',
    LIKE_NEW = 'LIKE_NEW',
    GOOD = 'GOOD',
    FAIR = 'FAIR',
    POOR = 'POOR',
    DAMAGED = 'DAMAGED',
  }
}
